const idScroll = (id ,offset = 0) => {
  const scrollTarget = document.getElementById(id.replace(/^#/,''));
  if(scrollTarget){
    const clientRect = scrollTarget.getBoundingClientRect();
    const pageYOffsetTop = window.pageYOffset + clientRect.top ;
    window.scrollTo({
      top: pageYOffsetTop - offset,
      left: 0,
      behavior: 'smooth',
    });
  }
}

document.addEventListener("DOMContentLoaded", function(){
  document.addEventListener('click', function(e) {
    if (e.target && e.target.hasAttribute("href")) {
      const id = e.target.getAttribute("href");
      if(id.match(/^#/)){
        e.preventDefault()
        const fixedElm = document.querySelector('#Header-Sticky .header__bottom')
        const offset = fixedElm.display !== 'none' ? fixedElm.offsetHeight : 0 ;
        idScroll(id,offset + 15)
      }
    }
  });

  const banner = document.querySelector('.js-banner-area');
  if(banner){
    const parentElement = banner.parentElement;
    const bannerHeight = banner.offsetHeight;
    parentElement.style.height = bannerHeight + 'px';

    const scrollOfset = banner.offsetTop;
    const className = 'active';

    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset;
      if(scrollTop >= scrollOfset) {
        banner.classList.add(className);
      } else {
        banner.classList.remove(className);
      }
    });
  }
})

if(typeof ScrollHint !== 'undefined'){
  new ScrollHint('.fc-table')
  document.querySelectorAll('.fc-table').forEach((el)=>{
    el.insertAdjacentHTML('beforebegin', '<div class="fc-table-topScroll"><p class="fc-table-topScroll__inner"></p></div>');
    const topScroll = el.previousSibling
    const topScrollInner = el.previousSibling.firstChild
    const table = el.getElementsByTagName('table')[0]
    topScrollInner.style.width = table.offsetWidth + 'px'
    topScroll.append(topScrollInner)
    el.addEventListener('scroll', () => {topScroll.scrollTo(el.scrollLeft,0)})
    topScroll.addEventListener('scroll', () => {el.scrollTo(topScroll.scrollLeft,0)})
    const widthCheckObserver = new MutationObserver((mutations) => {
      topScroll.style.overflowX = el.classList.contains("is-scrollable") ? 'scroll' : ''
    });
    widthCheckObserver.observe(el, {attributes: true});
  })
}
